import { useConsecutivo } from "../../../../hooks/useConsecutivo";
import {
  Page,
  Left,
  Right,
  HeaderRow,
  RoleListContainer,
  RoleItem,
  SearchInput,
} from "../styles/component.style";
import { BtnGeneral } from "../../../../styles/Buttons";
import SearchableSelect from "../../../../components/Common/SearchableSelect";

export default function Consecutivo() {
  const {
    consecutivos,
    empresas,
    selectedCons,
    handleSelectCons,
    saveCons,
    handleNew,
    setForm,
    form,
    search,
    setSearch,
    inactiveCons
  } = useConsecutivo();

  const filteredCons = consecutivos
    .filter(
      (r) =>
        (r.Api?.toLowerCase() || "").includes(search.toLowerCase()) ||
        (r.Consecutivo?.toString() || "").includes(search)
    )
    .slice(0, search ? consecutivos.length : 20);

  return (
    <Page>
      {/* ================= PANEL IZQUIERDO ================= */}
      <Left>
        <HeaderRow>
          <h3>Consecutivos</h3>
          <BtnGeneral
            bg="cyan"
            padding="6px 10px"
            radius="6px"
            fw="600"
            onClick={handleNew}
          >
            Nuevo
          </BtnGeneral>
        </HeaderRow>

        <SearchInput
          placeholder="Buscar x Codigo, Descripción......"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <RoleListContainer>
          {filteredCons.length > 0 ? (
            filteredCons.map((c) => (
              <RoleItem
                key={c.id}
                active={selectedCons === c.id}
                onClick={() => handleSelectCons(c.id)}
              >
                <strong>
                  {c.Consecutivo ? `${c.Consecutivo} - ` : ""}{c.Api}
                </strong>
                {c.empresa_nombre && (
                  <div style={{ fontSize: "10.5px", color: "#64748b" }}>{c.empresa_nombre}</div>
                )}
              </RoleItem>
            ))
          ) : (
            <div style={{ padding: "12px", color: "#94a3b8", textAlign: "center", fontSize: "12px" }}>
              {search ? "No se encontraron consecutivos" : "No hay consecutivos registrados"}
            </div>
          )}
        </RoleListContainer>
      </Left>

      {/* ================= PANEL DERECHO ================= */}
      <Right>
        <HeaderRow>
          <h3>{form.id ? "Editar consecutivo" : "Nueva consecutivo"}</h3>
          <BtnGeneral
            bg="green"
            padding="6px 10px"
            radius="6px"
            fw="600"
            onClick={saveCons}
          >
            Guardar
          </BtnGeneral>
        </HeaderRow>

        <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
          {/* COLUMNA 1 */}
          <div style={{ flex: 1 }}>
            <label>ID</label>
            <input disabled value={form.id} style={inputStyle} />

            <label>Descripcion</label>
            <input
              value={form.api}
              onChange={(e) => setForm({ ...form, api: e.target.value })}
              style={inputStyle}
            />

            <label>Resultado</label>
            <SearchableSelect
              key={`resultado-${form.id || "new"}`}
              value={String(form.resultado ?? "1")}
              onValueChange={(val) => setForm({ ...form, resultado: val })}
              options={[
                { value: "1", label: "SI" },
                { value: "0", label: "NO" },
              ]}
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "12px", ...selectSx }}
            />

            <label>Empresa</label>
            <SearchableSelect
              key={`empresa-${form.id || "new"}`}
              value={form.id_empresa !== undefined && form.id_empresa !== null ? String(form.id_empresa) : "0"}
              onValueChange={(val) => setForm({ ...form, id_empresa: parseInt(val, 10) })}
              options={[
                { value: "0", label: "Ninguna" },
                ...(empresas || []).map((e) => ({
                  value: String(e.id),
                  label: e.nombre_empresa || e.descripcion || e.nombre || String(e.id),
                })),
              ]}
              placeholder="Seleccione empresa..."
              multiple={false}
              searchable={true}
              size="small"
              sx={{ mb: "12px", ...selectSx }}
            />
          </div>

          {/* COLUMNA 2 */}
          <div style={{ flex: 1 }}>
            <label>Consecutivo</label>
            <input
              disabled={inactiveCons}
              type="number"
              value={form.Consecutivo}
              onChange={(e) =>
                setForm({ ...form, Consecutivo: e.target.value })
              }
              style={inputStyle}
            />

            <label>Orden</label>
            <input
              type="number"
              value={form.orden}
              onChange={(e) => setForm({ ...form, orden: e.target.value })}
              style={inputStyle}
            />

            <label>Estado</label>
            <SearchableSelect
              key={`estado-${form.id || "new"}`}
              value={String(form.estado ?? "1")}
              onValueChange={(val) => setForm({ ...form, estado: val })}
              options={[
                { value: "1", label: "ACTIVO" },
                { value: "0", label: "INACTIVO" },
              ]}
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "12px", ...selectSx }}
            />
          </div>
        </div>
      </Right>
    </Page>
  );
}

const inputStyle = {
  width: "100%",
  padding: "6px",
  marginBottom: "12px",
  borderRadius: "6px",
  border: "1px solid #cbd5e1",
};

const selectSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
    backgroundColor: "#ffffff",
    "& fieldset": { borderColor: "#cbd5e1" },
    "&:hover fieldset": { borderColor: "#94a3b8" },
    "&.Mui-focused fieldset": { borderColor: "#007bba" },
  },
  "& .MuiSelect-select": {
    padding: "6px 10px !important",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
  },
};
